import _get from "lodash/get";
import _times from "lodash/times";

import Button from "@components/Button";
import RatingStar from "@components/Icons/RatingStar";

const ProductReviewsInfo = ({
  reviewsSummary,
  placeholder,
  visibleForm,
  userCanPostReview,
}) => {
  const reviewsCount = _get(reviewsSummary, "reviews.value", 0);
  const reviewsRating = _get(reviewsSummary, "reviews.total", 0);
  return (
    <div className="md:flex items-center">
      <div style={{ minWidth: "200px" }}>
        {reviewsSummary && (
          <>
            <h4 className="my-0 text-4xl lg:text-40px text-black font-medium">
              {isNaN(reviewsRating / reviewsCount)
                ? 0
                : parseFloat(reviewsRating / reviewsCount).toFixed(2)}{" "}
              <span className="text-gray-light"> din 5</span>
            </h4>

            <div className="mb-4">
              <div className="relative inline-block">
                <div className="flex items-center">
                  {/* Generate neutral rating stars */}
                  {_times(5, (i) => {
                    return (
                      <RatingStar
                        width="32px"
                        height="29px"
                        className="mr-1 text-gray-light"
                        key={i}
                      />
                    );
                  })}
                </div>
                <div
                  className="absolute inline-block top-0 left-0 right-0 overflow-hidden"
                  style={{
                    width: `${
                      reviewsRating / reviewsCount <= 5
                        ? parseFloat(
                            (
                              ((reviewsRating / reviewsCount) * 100) /
                              5
                            ).toFixed(2)
                          )
                        : 0
                    }%`,
                  }}
                >
                  <div className="flex items-center">
                    <div className="flex items-center">
                      {/* Generate filled rating stars */}
                      {_times(5, (i) => {
                        return (
                          <RatingStar
                            width="32px"
                            height="29px"
                            className="mr-1 fill-current flex-none text-yellow"
                            key={i}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="hidden md:block">
          <Button
            title="Adauga recenzia ta"
            display="block"
            disabled={visibleForm || placeholder}
            size="normal"
            onClick={() => userCanPostReview()}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductReviewsInfo;
